export default "__VITE_ASSET__Xp9jxoTp__"